module.exports = __webpack_public_path__ + "static/img/W_RTW.6317e22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_RTW.jpg
// module id = n3Ih
// module chunks = 1